import { incomeCategoryUpdateApi } from "../../api/incomeCategory/incomeCategoryUpdateApi"

type PayloadShape = Parameters<typeof incomeCategoryUpdateApi>[0]

export async function incomeCategoryUpdateService(payload: PayloadShape, token: string) {
	return await incomeCategoryUpdateApi(payload, token)
}
